import propTypes from 'prop-types';
import { copyTextToClipboard } from '../../common/helpers/copyToClipboard.js';
import { NotifyPopUp } from './ConfigurationGroup/NotifyPopup/NotifyPopUp.jsx';
import { PesIcon } from '@pes-ui/components-react';
import { pesIconSizes } from '@pes-ui/components/dist/collection/components/UI/pes-icon/constants';

export const shouldRenderCustomizationFields = (card) => card.customizationId || card.productCr;

export const CustomizationFields = (props) => {
  const {
    customizationId,
    productCr,
    shouldRenderNotification,
    card: { labelsStore },
    showClipboardNotify
  } = props;

  const copyToClipboardHandler = async () => {
    try {
      await copyTextToClipboard(customizationId);
      requestAnimationFrame(showClipboardNotify); 
    } catch (error) {
      console.error('Error copying to clipboard:', error);
    }
  };

  const renderCustomizationCopyingControls = () => (
    <button
        type="button"
        className="customizationId-copy button-less"
        onClick={copyToClipboardHandler}
    >
      <PesIcon class="actions-block__cta-icon cart-group__icon-svg" size={pesIconSizes.MICRO}>
        action_duplicate
      </PesIcon>
    </button>
  );

  const renderCustomizationId = () => (
    <div>
      <span>{labelsStore.customizationId}</span>
      :
      {' '}
      {customizationId}
      {renderCustomizationCopyingControls()}
    </div>
  );

  const renderProductCr = () => (
    <div>
      <span>{labelsStore.product}</span>
      :
      {' '}
      {productCr}
    </div>
  );

  return (
    <div className="my-card__customization">
      {customizationId && renderCustomizationId()}
      {productCr && renderProductCr()}
      {shouldRenderNotification && <NotifyPopUp />}
    </div>
  );
};

CustomizationFields.propTypes = propTypes.shape({
  customizationId: propTypes.string,
  productCr: propTypes.string,
  shouldRenderNotification: propTypes.bool,
  showClipboardNotify: propTypes.func,
  card: propTypes.shape({
    labelsStore: propTypes.shape({
      product: propTypes.string,
      customizationId: propTypes.string
    })
  })
}).isRequired;
